/* eslint-disable */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropInputTextArea from "../../../ui-components/raindrop-input-text-area/raindrop-input-text-area.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop.js";

const CirrusRegisterOrganisation = ({
  currentOrganisationUser,
  setCurrentOrganisationUser,
}) => {
  const navigate = useNavigate();

  const [nameOrganisation, setNameOrganisation] = React.useState<string>("");
  const [website, setWebsite] = React.useState<string>("");
  const [sortCode, setSortCode] = React.useState<string>("");
  const [accountNumber, setAccountNumber] = React.useState<string>("");
  const [charityNumber, setCharityNumber] = React.useState<string>("");
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const [descriptionShort, setDescriptionShort] = React.useState<string>("");
  const [organisationEmail, setOrganisationEmail] = React.useState<string>("");
  const [organisationAddressLine1, setOrganisationAddressLine1] =
    React.useState<string>("");
  const [organisationAddressCity, setOrganisationAddressCity] =
    React.useState<string>("");
  const [organisationAddressPostcode, setOrganisationAddressPostcode] =
    React.useState<string>("");

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const onSubmit = async () => {
    try {
      setIsSubmitting(true);

      await fetchGraphQL(`
        mutation {
        organisationCreate(
          name: "${nameOrganisation}",
          urlWebsite: "${website}",
          accountNumber: "${accountNumber}",
          accountSortCode: "${sortCode}",
          descriptionShort: "${descriptionShort}",
          charityNumber: "${charityNumber}",
          organisationEmail: "${organisationEmail}",
          organisationAddressLine1: "${organisationAddressLine1}",
          organisationAddressCity: "${organisationAddressCity}",
          organisationAddressPostcode: "${organisationAddressPostcode}",
          organisationType: "ORGANISATION_TYPE__CHARITY",
        ) {
          id
        }
      } 
      `);

      setCurrentOrganisationUser(null);

      navigate(`/cirrus`);
    } catch (error) {
      setErrorMessage("Something went wrong, please try again. (RD-5632)");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex w-full  justify-center overflow-y-auto p-6 text-color-text-primary">
      <form
        className={`flex flex-col w-full max-w-3xl  p-6 rounded-lg gap-6 shadow
      bg-color-background-primary dark:bg-color-dark-background-primary border dark:border-color-dark-border-tertiary dark:text-color-dark-text-primary
      `}
      >
        <div className="flex flex-col gap-2 w-full">
          <div className="text-lg font-bold ">Register your organisation</div>
          <div className="text-xs text-color-dark-text-secondary">
            The registration process can take a while and we will require
            additional validation after initial registration.
          </div>
        </div>
        <div className="flex flex-row w-full gap-6">
          <div className="flex flex-col w-full gap-4">
            <RaindropInput
              placeholder="Organisation Name"
              example="Droplet Foundation"
              value={nameOrganisation}
              onChange={(e) => setNameOrganisation(e.target.value)}
              label="Organisation Name"
              isShowLabel={true}
              icon=""
            />
            <RaindropInputTextArea
              example="We use our funds to bring water to people in need."
              value={descriptionShort}
              onChange={(e) => setDescriptionShort(e.target.value)}
              label="Short Description"
            />
            <RaindropInput
              placeholder="Charity Number"
              example="1234567"
              value={charityNumber}
              onChange={(e) => setCharityNumber(e.target.value)}
              label="Charity Number"
            />

            <RaindropInput
              placeholder="Website"
              example="https://www.theraindropcompany.com"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
              label="Website"
              isShowLabel={true}
              icon=""
            />
            <RaindropInput
              placeholder="Sort Code"
              value={sortCode}
              example="108800"
              onChange={(e) => setSortCode(e.target.value)}
              label="Sort Code"
              isShowLabel={true}
              icon=""
            />
            <RaindropInput
              placeholder="Account Number"
              example="00012345"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              label="Account Number"
              isShowLabel={true}
              icon=""
            />
          </div>
          <div className="flex flex-col w-full gap-4">
            <RaindropInput
              example="finance@example.com"
              value={organisationEmail}
              onChange={(e) => setOrganisationEmail(e.target.value)}
              label="Organisation Email"
              isShowLabel={true}
              icon=""
            />
            <RaindropInput
              example="address_full_match"
              value={organisationAddressLine1}
              onChange={(e) => setOrganisationAddressLine1(e.target.value)}
              label="Organisation Address Line 1"
            />
            <RaindropInput
              example="London"
              value={organisationAddressCity}
              onChange={(e) => setOrganisationAddressCity(e.target.value)}
              label="Organisation Address City"
            />
            <RaindropInput
              example="E1 1AA"
              value={organisationAddressPostcode}
              onChange={(e) => setOrganisationAddressPostcode(e.target.value)}
              label="Organisation Address Postcode"
            />
          </div>
        </div>
        <div className="flex flex-row justify-end">
          <RaindropButton
            title="Submit"
            onClick={onSubmit}
            isLoading={isSubmitting}
            style={ButtonStyle.Primary}
            icon="fa-check"
          />
        </div>
        <div>{errorMessage}</div>
      </form>
    </div>
  );
};

export default CirrusRegisterOrganisation;
